import { Injectable } from '@angular/core';
import { LogPublisher } from './log-publisher';
import { LogToConsole } from './log-to-console';
import { LogToLocalStorage } from './log-to-local-storage';
import { LogToWebApi } from './log-to-web-api';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class LogPublisherService {
    constructor(private _http:HttpClient) {
        this.buildPublishers();
    }

    publishers: LogPublisher[] = [];

    buildPublishers(): void {
        //TODO: config should set it
        this.publishers.push(new LogToConsole());
        this.publishers.push(new LogToLocalStorage());
        this.publishers.push(new LogToWebApi(this._http));
    }
}
